import React from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

import {
  ResultWrapper,
  SkeletonResult,
  PopularDestinationOffers,
  Contact,
  CompanyLogos,
  SearchBenefits,
  AboutUs,
  RecentSearchesWrapper,
  Banner,
  CustomGetaways,
  GetawayList
} from '@components';
import { SearchWrapper } from '@share/components';
import { IBenefitsState, ILoginState, IMenuState } from '@share/store/slices';
import { IHotelsState } from '@share/store/slices';
import { CanImpersonate, IsImpersonating, RootState, LoginType } from '@share/utils';
import { Responsive } from '@share/utils';
import { HotelsCompanyLogos } from '@common-types';
import { GetawaysLocationEnum, IAccount, PRIMARY_BANNER_TYPE, SECONDARY_BANNER_TYPE } from '@share/common-types';
import { LifeStyleMessage } from '@components';
import { NULL_VALUE } from '@constants';

import { FeaturedDestinations } from '../featured-destinations';

import './style.scss';

interface IMapStateToProps {
  hotelsStore: IHotelsState;
  menuStore: IMenuState;
  loginStore: ILoginState;
  benefitsStore: IBenefitsState;
}

interface IProps extends IMapStateToProps {
  isVacationRentals: boolean;
}

class SearchTravcodingComponent extends React.Component<IProps> {
  render(): React.ReactNode {
    const { hotelsStore, loginStore, isVacationRentals, benefitsStore } = this.props;
    const { hotels, loading, searchedLocation, error } = hotelsStore;
    const { account } = loginStore;
    
    const hasPublicAccessToken = account?.hasPublicAccessToken;
    const hideThingsMatterSection = account?.hideThingsMatterSection;
    const hasDisplayContactSection = account?.hasDisplayContactSection;
    const hasDisplayTrustedBrandsSection = account?.hasDisplayTrustedBrandsSection;

    const hasPublicValidToken = account?.type !== LoginType.Public || !hasPublicAccessToken || !isEmpty(loginStore.accessToken);

    const showImpersonate = CanImpersonate(account as IAccount) && !IsImpersonating() && !account?.disableImpersonate && account?.forceImpersonate;

    return (
      <div className="search-travcoding">
        <SearchWrapper isVacationRentals={isVacationRentals} />
        {!hotels && (
          <>
            {(hasPublicValidToken && !showImpersonate) && (
              <RecentSearchesWrapper isVacationRentals={isVacationRentals} />)}

            {hasPublicValidToken && (
              <PopularDestinationOffers />)}

            {account?.displayGetawaysHomeHotels ?
              account?.displayGetawaysHomeHotelsSlider ? (
                <GetawayList
                  getaway={GetawaysLocationEnum.Staycation}
                  condoSubcategory={NULL_VALUE}
                
                  isFromProperty
                  isInternal
                  isHome
                  isSlider
                />) : (
                <CustomGetaways benefits={benefitsStore?.benefits} noPaddingTop isFromHome />) : null}

            <Banner type={PRIMARY_BANNER_TYPE} />
            
            <LifeStyleMessage />

            <FeaturedDestinations isVacationRentals={isVacationRentals} />

            {hasDisplayContactSection ? (<Contact />) : null}

            {!hideThingsMatterSection ? (
              <SearchBenefits />) : null}

            {hasDisplayTrustedBrandsSection ? (<CompanyLogos logos={HotelsCompanyLogos} />) : null}

            <AboutUs />

            <Banner type={SECONDARY_BANNER_TYPE} />
          </>
        )}
        {hotels && loading && isEmpty(error) ? <SkeletonResult /> : null}
        {(hotels || !isEmpty(error)) && !loading ? (
          <Responsive>
            <ResultWrapper label={searchedLocation} isVacationRentals={isVacationRentals} />
          </Responsive>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    hotelsStore: state.hotelsStore,
    menuStore: state.navigationMenuStore,
    loginStore: state.loginStore,
    benefitsStore: state.benefitsStore
  };
};

export const SearchTravcoding = connect(mapStateToProps)(SearchTravcodingComponent);
